import React, { useState } from 'react';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

import { Avatar, Text, ContainedButton, Tag, GroupIcon } from '../index';

import { StyledCard, StyledCardContent } from './style';

import { SESSION_COLORS, SMALL_SESSION_TYPE } from '../../constant';

dayjs.extend(isBetween);

export const PatientSessionCard = ({ $maxWidth, $minWidth, onClick, data, $style, onCheckIn }) => {
    const [today] = useState(dayjs());

    return (
        <StyledCard
            style={{ padding: '12px 15px', cursor: 'pointer', overflow: 'visible', ...$style }}
            onClick={onClick}
            $maxWidth={$maxWidth}
            $minWidth={$minWidth}
        >
            <StyledCardContent
                style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    rowGap: '10px',
                }}
            >
                <div style={{ display: 'flex', columnGap: '10px' }}>
                    <Tag
                        style={{ height: '21px' }}
                        $backgroundColor={SESSION_COLORS[data?.meet?.type]}
                    >
                        <Text
                            $medium
                            $fontSize="10px"
                            $color="white"
                            style={{ textTransform: 'uppercase ' }}
                        >
                            {SMALL_SESSION_TYPE[data?.meet?.type]}
                        </Text>
                    </Tag>
                    {data?.meet?.numberOfParticipants && (
                        <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                            <GroupIcon fill="gray2" width="16px" height="16px" />
                            <Text $color="gray2" $fontSize="12px">
                                {data.meet.numberOfParticipants}
                            </Text>
                        </div>
                    )}
                </div>
                <div>
                    <Text $fontSize="14px" $ellipsis $medium>
                        {data?.meet?.name}
                    </Text>

                    <Text $color="gray2" $fontSize="12px">
                        {`${
                            dayjs(data.date || data.startDate).isSame(today, 'day')
                                ? 'Today'
                                : dayjs(data.date || data.startDate).format('DD MMM YYYY')
                        }, ${today
                            .set({
                                hour: data.startTime.split(':')[0],
                                minute: data.startTime.split(':')[1],
                            })
                            .format('HH:mm')} - ${today
                            .set({
                                hour: data.endTime.split(':')[0],
                                minute: data.endTime.split(':')[1],
                            })
                            .format('HH:mm')}`}
                    </Text>
                </div>

                <div style={{ display: 'flex', columnGap: '10px', alignItems: 'center' }}>
                    <Avatar
                        src={data?.meet?.staff?.user?.avatar?.url}
                        alt={data?.meet?.staff?.user?.fullname}
                        $avatarSize="30px"
                    />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Text $color="gray1" $fontSize="12px">
                            {data?.meet?.staff?.user?.fullname}
                        </Text>
                        <Text $color="gray1" $fontSize="10px">
                            {data?.meet?.hospital?.name}
                        </Text>
                    </div>
                </div>

                {onCheckIn && (
                    <ContainedButton
                        $height="40px"
                        onClick={onCheckIn}
                        disabled={
                            !dayjs().isBetween(
                                dayjs(data.date)
                                    .set({
                                        hour: data.startTime.split(':')[0],
                                        minute: data.startTime.split(':')[1],
                                    })
                                    .subtract(10, 'minute'),
                                dayjs(data.date).set({
                                    hour: data.endTime.split(':')[0],
                                    minute: data.endTime.split(':')[1],
                                }),
                                'minute',
                                '()'
                            )
                        }
                    >
                        {data?.meet?.type === 'open' ? 'Join Now' : 'Check in'}
                    </ContainedButton>
                )}
            </StyledCardContent>
        </StyledCard>
    );
};

PatientSessionCard.propTypes = {
    $maxWidth: PropTypes.string,
    $minWidth: PropTypes.string,
    onClick: PropTypes.func,
    data: PropTypes.object,
    $style: PropTypes.object,
    onCheckIn: PropTypes.func,
};
